// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import {getAuth} from "firebase/auth";
import { getStorage, ref, uploadBytes } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDI4Dp35jHDMa7Lukbc4HK9MTT10trTwyQ",
  authDomain: "circleops-5f8c7.firebaseapp.com",
  projectId: "circleops-5f8c7",
  storageBucket: "circleops-5f8c7.appspot.com",
  messagingSenderId: "295646526551",
  appId: "1:295646526551:web:e7560683e67cb1237bb712",
  measurementId: "G-QK9SRLVDB0"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp)
export { db, auth, storage };